/**
 * Standard subscription pricing (must match backend services/pricing.py).
 * Values are dollars (frontend display only).
 */
export const STANDARD_PATHS = [
  { key: "A", label: null, duration: "3 Months", subtext: "Per-query broker costs apply. No contingency fee." },
  { key: "B", label: null, duration: "6 Months", subtext: "Per-query broker costs apply. No contingency fee." },
  { key: "C", label: null, duration: "12 Months", subtext: "Per-query broker costs apply. No contingency fee.", badge: "BEST VALUE" },
];

export const STANDARD_PRICING = {
  1: { A: 199, B: 299, C: 499 },
  2: { A: 299, B: 449, C: 749 },
  3: { A: 398, B: 598, C: 998 },
};

export const PRO_PLANS = [
  { key: "monthly", label: "MONTHLY", duration: "$999 / month", price: 999, subtext: "Unlimited judgments. Cancel anytime." },
  { key: "annual", label: "ANNUAL", duration: "$9,990 / year", price: 9990, strike: 11988, badge: "2 MONTHS FREE", subtext: "Unlimited judgments. Best rate." },
];

export const TIERS = [
  { key: "bronze", label: "BRONZE", color: "var(--color-tier-bronze)", frequency: "every 12 months", description: "Ideal for lower-priority or dormant judgments." },
  { key: "silver", label: "SILVER", color: "var(--color-tier-silver)", frequency: "every 6 months", description: "Ideal for active cases with moderate asset movement." },
  { key: "gold", label: "GOLD", color: "var(--color-tier-gold)", frequency: "every 3 months", description: "Ideal for high-priority judgments with recent asset activity.", badge: "MOST ACTIVE" },
];

export const TIER_MONTHS = { bronze: 12, silver: 6, gold: 3 };

export const COURT_LEVELS = [
  "Small Claims Court",
  "County Court",
  "Circuit Court",
  "District Court",
  "Federal Court",
];

export const NATURE_OF_DEBT = [
  "Contract Dispute",
  "Personal Injury",
  "Property Damage",
  "Fraud or Misrepresentation",
  "Consumer Debt",
  "Child Support or Family",
  "Other",
];

export const EMPLOYMENT_STATUSES = [
  { value: "employed", label: "Employed" },
  { value: "self_employed", label: "Self-Employed" },
  { value: "unemployed", label: "Unemployed" },
  { value: "unknown", label: "Unknown" },
];

export const formatMoney = (cents, opts = {}) => {
  const val = Number(cents || 0) / 100;
  return val.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: opts.decimals ?? 2,
    maximumFractionDigits: opts.decimals ?? 2,
  });
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
};
